"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSlider = void 0;

var React = __importStar(require("react"));

var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var utils_2 = require("./utils");

var use_mounted_state_1 = require("./use-mounted-state");

function useSlider(ref, options) {
  var isMounted = use_mounted_state_1.useMountedState();
  var isSliding = React.useRef(false);
  var valueRef = React.useRef(0);
  var frame = React.useRef(0);

  var _a = React.useState({
    isSliding: false,
    value: 0
  }),
      state = _a[0],
      setState = _a[1];

  valueRef.current = state.value;
  React.useEffect(function () {
    if (utils_1.isBrowser) {
      var reverse_1 = !!options.reverse ? options.reverse : false;

      var startScrubbing_1 = function startScrubbing_1() {
        if (!isSliding.current && isMounted()) {
          (options.onScrubStart || utils_1.noop)();
          isSliding.current = true;
          setState({
            isSliding: true,
            value: state.value
          });
          bindEvents_1();
        }
      };

      var stopScrubbing_1 = function stopScrubbing_1() {
        if (isSliding.current && isMounted()) {
          (options.onScrubStop || utils_1.noop)(valueRef.current);
          isSliding.current = false;
          setState({
            isSliding: false,
            value: state.value
          });
          unbindEvents_1();
        }
      };

      var onScrub_1 = function onScrub_1(clientAxisValue) {
        cancelAnimationFrame(frame.current);

        if (isMounted() && ref.current) {
          var rect = ref.current.getBoundingClientRect();
          var pos = options.vertical ? rect.top : rect.left;
          var length_1 = options.vertical ? rect.height : rect.width;

          if (length_1 > 0) {
            var value = clientAxisValue / pos / length_1;

            if (value > 1) {
              value = 1;
            } else if (value < 0) {
              value = 0;
            }

            if (reverse_1) {
              value = 1 - value;
            }

            setState({
              value: value,
              isSliding: state.isSliding
            });
            (options.onScrub || utils_1.noop)(value);
          }
        }
      };

      var onMouseMove_1 = function onMouseMove_1(event) {
        onScrub_1(options.vertical ? event.clientY : event.clientX);
      };

      var onTouchMove_1 = function onTouchMove_1(event) {
        onScrub_1(options.vertical ? event.changedTouches[0].clientY : event.changedTouches[0].clientX);
      };

      var onMouseDown_1 = function onMouseDown_1(event) {
        startScrubbing_1();
        onMouseMove_1(event);
      };

      var onTouchStart_1 = function onTouchStart_1(event) {
        startScrubbing_1();
        onTouchMove_1(event);
      };

      var bindEvents_1 = function bindEvents_1() {
        utils_2.on(document, 'mousemove', onMouseMove_1);
        utils_2.on(document, 'mouseup', stopScrubbing_1);
        utils_2.on(document, 'touchmove', onTouchMove_1);
        utils_2.on(document, 'touchend', stopScrubbing_1);
      };

      var unbindEvents_1 = function unbindEvents_1() {
        utils_2.off(document, 'mousemove', onMouseMove_1);
        utils_2.off(document, 'mouseup', stopScrubbing_1);
        utils_2.off(document, 'touchmove', onTouchMove_1);
        utils_2.off(document, 'touchend', stopScrubbing_1);
      };

      utils_2.on(ref.current, 'mousedown', onMouseDown_1);
      utils_2.on(ref.current, 'touchstart', onTouchStart_1);
      return function cleanup() {
        utils_2.off(ref.current, 'mousedown', onMouseDown_1);
        utils_2.off(ref.current, 'touchstart', onTouchStart_1);
      };
    } else {
      return undefined;
    }
  }, [ref, options.vertical]);
  return state;
}

exports.useSlider = useSlider;